module.exports = __webpack_public_path__ + "static/turtle-creek-house41-0fe0c3f6509681d61b625ce1590bf293.jpg";